import styled from 'styled-components'
import PropTypes from 'prop-types'

const Fade = styled.div.withConfig({
  shouldForwardProp: prop => ![
    'active',
    'hover',
  ].includes(prop),
})`
  transition: ${props =>
    props.theme.internalMixins.setTransition(['opacity', 'visibility'])};
  ${props => (props.active ? props.theme.state.show : props.theme.state.hide)}
  ${props =>
    props.hover &&
    `
    &:hover {
      ${props.theme.state.show}
    }
  `}
`

Fade.propTypes = {
  active: PropTypes.bool,
  hover: PropTypes.bool,
}

Fade.defaultProps = {
  active: false,
  hover: false,
}

export default Fade
